$(function() {
  $(document).on('click', 'a[href^="#"]', function(e) {
    e.preventDefault();
    let target = $(document.getElementById($(this).attr('href').replace('#', '')));
    
    if (target.length) {
      $('html, body').animate({
        scrollTop: target.offset().top  - $('header').outerHeight(),
      }, 1000, 'swing');
    }
  });

  window.scrollTo = function(targetName) {
    const target = $(targetName);

    if (target.length) {
      let offset = target.offset().top - $('header').outerHeight();

      $('html, body').animate({
        scrollTop: offset,
      }, 1000);
    }
  };
  
  jQuery(document).on('gform_post_render', function(event, form_id, current_page){ // eslint-disable-line
    if ($('#gform_wrapper_' + form_id + '.gform_validation_error').length) {
      if($('.modal.active').length) {
        var scrollableDiv = $('.modal');
        scrollableDiv.scrollTop(0);
      }else {
        $('html, body').animate({
          scrollTop: $('#gform_' + form_id).offset().top - $('header').outerHeight() - $('header').outerHeight(),
        }, 1000);
      }
    }
  });
});
